enum AttachmentMenuAction {
    ChangePermissions,
    CopyLink,
    Download,
    OpenInNewTab,
    Preview,
    SaveToCloud,
    ViewInProvider,
    ConvertClassicToCloudy,
    ConvertCloudyToClassic,
    ImportCalendarEventAttachment,
    MoveAttachmentToInline,
    RefreshLink,
    IgnoreExpiration,
}

export default AttachmentMenuAction;
